import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ICourseSession,
  ICourseTerm,
} from "../../../models/admin/courseTermSession.model";
import { IDefferedRequests } from "../../../models/admin/deferred.model";
import AdminHelpers from "../../../services/admin/admin.service";
import DefermentService from "../../../services/admin/deferment.service";
import { getLocalUserProfile } from "../../../services/auth.service";

export const ApproveRejectDeferModal: React.FC<any> = ({
  isOpen,
  onClosed,
  isDefer = false,
  data,
  reload,
}: {
  isDefer: boolean;
  isOpen: any;
  onClosed: any;
  data: IDefferedRequests;
  reload: any;
}) => {
  const toast = useToast();
  const cancelRef = useRef().current;
  const [deferedData, setDeferredData] = useState<IDefferedRequests>();
  const [session, setSession] = useState<ICourseSession[]>([]);
  const [term, setTerms] = useState<ICourseTerm[]>([]);
  console.log(deferedData, "Hiiiii");

  const navigate = useNavigate();
  useEffect(() => {
    if (data) setDeferredData(data);
    const user = getLocalUserProfile();
    AdminHelpers.getSessions()
      .then((response) => {
        setSession(response.data);
      })
      .catch((err) => err);
    AdminHelpers.getTerms()
      .then((response) => {
        setTerms(response.data);
      })
      .catch((err) => err);
  }, []);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};

      if (!values.new_session) {
        errors.new_session = "Please select new session!";
      }
      if (!values.term) {
        errors.term = "Please select new term!";
      }

      return errors;
    },
    initialValues: {
      new_session: deferedData?.defer_till_session_id,
      term: deferedData?.defer_till_term_id,
    },
    onSubmit: async (values) => {
      try {
        const approvereqdata: any = {
          defer_admission_id: deferedData?.id.toString(),
          new_session_id: values.new_session,
          new_term_id: values.term,
          status: "approve",
        };
        const approvedeferRequest = await DefermentService.processDeferRequest(
          approvereqdata
        );

        if (approvedeferRequest) {
          toast({
            title: "Approve Defer Request",
            description: `${approvedeferRequest.message}`,
            status: "success",
            duration: 2000,
            onCloseComplete: () => closeModal(),
          });
          reload();
        }
      } catch (error: any) {
        toast({
          title: "Approve Defer Request",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });
  const closeModal = () => {
    onClosed();
  };

  return (
    <>
      <Modal
        isOpen={isOpen && isDefer}
        onClose={onClosed}
        scrollBehavior="inside"
        closeOnOverlayClick={true}
        size="sm"
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={4}>
          <ModalHeader>
            {
              <Text
                fontSize="21px"
                fontWeight="700"
                pb={1}
                textTransform="none"
                pl={3}
                color="#2B2B2B"
              >
                Defer Admission
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="sm" />
          <ModalBody pb={6}>
            <Box mt={2}>
              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  mb="20px"
                  isInvalid={
                    formik.errors.new_session && formik.touched.new_session
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    New Session *
                  </FormLabel>
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="sm"
                    placeholder="Select session"
                    value={formik.values.new_session}
                    name="new_session"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {session.map((each, index) => (
                      <option key={index} value={each.id}>
                        {" "}
                        {each.title}{" "}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.new_session}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mb="20px"
                  isInvalid={
                    formik.errors.term && formik.touched.term ? true : false
                  }
                >
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    New Term
                  </FormLabel>
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="sm"
                    placeholder="Select term"
                    value={formik.values.term}
                    name="term"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {term.map((each, index) => (
                      <option key={index} value={each.id}>
                        {" "}
                        {each.title}{" "}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.term}
                  </FormErrorMessage>
                </FormControl>
                <Flex mt={12} justifyContent="end">
                  <HStack>
                    <Button
                      size="sm"
                      px={6}
                      fontSize={12}
                      ref={cancelRef}
                      onClick={() => onClosed()}
                    >
                      Cancel
                    </Button>
                    <Button
                      colorScheme="red"
                      type="submit"
                      isLoading={formik.isSubmitting}
                      size="sm"
                      px={6}
                      fontSize={12}
                    >
                      {" "}
                      Defer
                    </Button>
                  </HStack>
                </Flex>
              </form>
            </Box>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
